import { Form, Formik } from "formik";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { Card, Data } from "../../../store/card/types";
import SectionWrapper from "../../../common/pageSections/SectionWrapper";
import { Grid } from "@mui/material";
import CardBinForm from "./CardBin";
import FormSubmitButtons from "../../../common/buttons/FormSubmitButtons";
import React, { memo } from "react";
import * as Yup from "yup";
import { saveRequest } from "../../../store/card/actions";
import pageStyles from "../../pageStyles";
import TextInput from "../../../common/formElements/TextInput";
import { useToastMessage } from "../../../effects/useToastMessage";
import { toast } from "react-toastify";

const schema = Yup.object({
  attributes: Yup.object({
    Name: Yup.string().required("Card Prefix Name is required"),
    CardBin: Yup.array(
      Yup.object().shape({
        DescLong: Yup.string(),
        DescShort: Yup.string(),
        Bin: Yup.array(
          Yup.object().shape({
            From: Yup.string()
              .min(6, "Bin number must be at least 6 characters")
              .max(9, "Bin number must be at most 9 characters"),
            To: Yup.string()
              .min(6, "Bin number must be at least 6 characters")
              .max(9, "Bin number must be at most 9 characters"),
          })
        ),
      })
    ),
  }),
});

interface FormInput extends Data {
  _prepared?: boolean;
}

interface Props {
  card?: Data;
  isCreate: boolean;
}

function CardEditForm({ card, isCreate }: Props) {
  const initialValues: FormInput = card || {
    id: null,
    type: "Card",
    attributes: {
      Name: "",
      CardBin: [],
    },
  };

  const dispatch = useDispatch();
  const history = useHistory();
  const classes = pageStyles();

  return (
    <Formik
      validationSchema={schema}
      initialValues={initialValues}
      validateOnChange={false}
      onSubmit={(values, { setSubmitting }) => {
        const callback = (err: string | null, data: Card | null) => {
          if (err) {
            let errText = `An error occurred while saving: ${err}`;
            console.log(err);
            toast.error(errText, {
              closeOnClick: true,
            });
          } else {
            if (isCreate) {
              history.push("/card");
            } else {
              toast.success("Saved successfully!", {
                closeOnClick: true,
              });
            }
          }
          setSubmitting(false);
        };
        dispatch(saveRequest(values, callback));
      }}
    >
      {({ isSubmitting, errors }) => {
        // Show toast errors
        useToastMessage(isSubmitting, errors);
        return (
          <Form>
            <SectionWrapper title="Card Prefix">
              <Grid
                container
                alignItems="flex-start"
                spacing={3}
                className={classes.formWrapper as string}
              >
                <Grid item xs={12}>
                  <SectionWrapper title="General Info" isChild isWhiteBG>
                    <TextInput
                      fieldname="attributes.Name"
                      label="Card Prefix Name*"
                    />
                  </SectionWrapper>
                </Grid>
                <Grid item xs={12}>
                  <CardBinForm />
                </Grid>

                <FormSubmitButtons />
              </Grid>
            </SectionWrapper>
          </Form>
        );
      }}
    </Formik>
  );
}

export default memo(CardEditForm);
